import { useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Utils
 */
import { handleMapClickGeoJSON } from './_handleMapClickGeoJSON';
import { handleMapClickWMS } from './_handleMapClickWMS';

/**
 * Contexts
 */
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';
import { useToolsContext } from '../../context/ToolsContext';
import MapContext from '../Map/MapContext';

/**
 * Components
 */
import Tool from '../Tool/Tool';
import ModalWithTabs from './ModalWithTabs';
import EditGeometry from '../EditGeometry/EditGeometry';

/**
 * Herramienta de consulta de atributos sobre el mapa.
 * Ejecuta consultas GetFeatureInfo (WMS) y sobre entidades GeoJSON.
 */
function AttributeQuery() {
    const { t } = useTranslation();
    const { map } = useContext(MapContext);
    const { config, visibleOverlayLayers } = useGlobalVariablesContext();
    const { toolStates } = useToolsContext();

    const [features, setFeatures] = useState([]); // Almacena los datos de los features obtenidos
    const [editingFeature, setEditingFeature] = useState(null);
    const [editingLayer, setEditingLayer] = useState(null);

    useEffect(() => {
        if (!map || !toolStates?.attributes) return;

        const mapElement = map.getTargetElement();

        const handleClick = (event) => {
            setFeatures([]); // Limpiar resultados previos
            handleMapClickGeoJSON(event, map, setFeatures);
            handleMapClickWMS(event, map, visibleOverlayLayers, setFeatures, config);
        };

        if (toolStates.attributes.active) {
            map.on('singleclick', handleClick);
            if (mapElement) mapElement.style.cursor = 'help';
        } else {
            map.un('singleclick', handleClick);
            if (mapElement) mapElement.style.cursor = '';
        }

        return () => {
            if (map) map.un('singleclick', handleClick);
            if (mapElement) mapElement.style.cursor = '';
        };
    }, [toolStates, map]);

    const handleStartGeometryEdit = (olFeature, olLayer) => {
        setFeatures([]); // Cerrar modal
        setEditingFeature(olFeature);
        setEditingLayer(olLayer);
    };

    const handleEditEnd = () => {
        setEditingFeature(null);
        setEditingLayer(null);
    };

    return (
        <>
            <Tool
                id="attributes"
                type="toggleable"
                icon="bi bi-info-circle"
                label={t('Attribute query')}
            />
            {features.length > 0 && toolStates.attributes.active && (
                <ModalWithTabs 
                    features={features} 
                    setFeatures={setFeatures}
                    onStartGeometryEdit={handleStartGeometryEdit}
                />
            )}
            {editingFeature && editingLayer && (
                <EditGeometry
                    feature={editingFeature}
                    layer={editingLayer}
                    onEditEnd={handleEditEnd}
                />
            )}
        </>
    );
}

export default AttributeQuery;
